const CHX_TOKEN_ADDRESS = "0x38ca541aF1C22d2aD0FA811D9913aBc2B8D94938";
const CHX_STAKING_ADDRESS = "0x469A32e33C16905782e2B7d18Eba1f3Fa1fFe01A";

export { CHX_TOKEN_ADDRESS, CHX_STAKING_ADDRESS };
